import { render, staticRenderFns } from "./NonProfits.vue?vue&type=template&id=12762dce&scoped=true"
import script from "./NonProfits.vue?vue&type=script&lang=ts"
export * from "./NonProfits.vue?vue&type=script&lang=ts"
import style0 from "./NonProfits.vue?vue&type=style&index=0&id=12762dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12762dce",
  null
  
)

export default component.exports